import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';

var bnrimg = require('../../images/banner/privacidad.jpg');

const CookiePolicy = () => {
    const { t } = useTranslation();
    return (
        <>
            <Header />
            <div className="page-content">
                <Banner title={t('pages.legal.politicaCookies.bannerTitle')} pagename={t('pages.legal.politicaCookies.bannerPagename')} description={t('pages.legal.politicaCookies.bannerDescription')} bgimage={bnrimg} />

                <div className="section-full p-t80 p-b50 mobile-page-padding">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="service-single-block m-b30">
                                    <h3 className="m-b20">{t('pages.legal.politicaCookies.title')}</h3>
                                    <p>{t('pages.legal.politicaCookies.intro')}</p>

                                    <h4>{t('pages.legal.politicaCookies.usage.heading')}</h4>
                                    <p>{t('pages.legal.politicaCookies.usage.body1')}</p>
                                    <p>{t('pages.legal.politicaCookies.usage.body2')}</p>

                                    <h4>{t('pages.legal.politicaCookies.transparency.heading')}</h4>
                                    <p>{t('pages.legal.politicaCookies.transparency.body')}</p>

                                    <h4>{t('pages.legal.politicaCookies.contact.heading')}</h4>
                                    <p>{t('pages.legal.politicaCookies.contact.body')}</p>

                                    <p><strong>{t('pages.legal.politicaCookies.lastRevisionLabel')}</strong> {t('pages.legal.politicaCookies.lastRevisionValue')}</p>
                                    <p><strong>SoltArc Services</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default CookiePolicy;
